<template>
  <div>
    <div>
      <div
        class="floatBtn"
        :class="[{ moveBtn: longClick }, `${btnType}Btn`]"
        @touchstart="handleTouchStart($event)"
        @touchmove="handleTouchMove($event)"
        @touchend="handleTouchEnd($event)"
        @click="feedBack"
      >
        <div class="img-top-cover"></div>
        <img class="no-menu" src="../../assets/imgs/complaint.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      timeOutEvent: 0,
      longClick: 0,
      // 手指原始位置
      oldMousePos: {},
      // 元素原始位置
      oldNodePos: {},
      btnType: 'right'
    }
  },
  methods: {
    feedBack () {
      this.$router.push('/feedBack')
    },
    handleTouchStart (ev) {
      ev.stopPropagation() // 阻止事件冒泡
      // 定时器控制长按时间，超过300毫秒开始进行拖拽  为了避免出现微信浏览器的默认菜单 缩短至300
      this.timeOutEvent = setTimeout(() => {
        this.longClick = 1
        clearTimeout(this.timeOutEvent)
      }, 300)
      const selectDom = ev.currentTarget
      const { pageX, pageY } = ev.touches[0] // 手指位置
      const { offsetLeft, offsetTop } = selectDom // 元素位置
      // 手指原始位置
      this.oldMousePos = {
        x: pageX,
        y: pageY
      }
      // 元素原始位置
      this.oldNodePos = {
        x: offsetLeft,
        y: offsetTop
      }
      selectDom.style.left = `${offsetLeft}px`
      selectDom.style.top = `${offsetTop}px`
    },
    handleTouchMove (ev) {
      ev.preventDefault()
      ev.stopPropagation()
      // 未达到300毫秒就移动则不触发长按，清空定时器；长按时间太长回出现微信的默认菜单。
      if (this.longClick === 1) {
        const selectDom = ev.currentTarget
        // x轴偏移量
        const lefts = this.oldMousePos.x - this.oldNodePos.x
        // y轴偏移量
        const tops = this.oldMousePos.y - this.oldNodePos.y
        const { pageX, pageY } = ev.touches[0] // 手指位置
        selectDom.style.left = `${pageX - lefts}px`
        selectDom.style.top = `${pageY - tops}px`
      }
    },
    handleTouchEnd (ev) {
      // 清空定时器
      if (this.longClick === 1) {
        this.longClick = 0
        const selectDom = ev.currentTarget
        const { clientWidth, clientHeight } = document.body
        const { offsetLeft, offsetTop } = selectDom
        const newLeft = (offsetLeft + 50) > (clientWidth / 2) ? 'calc(100% - 64px)' : 0
        let newTop = offsetTop
        if (offsetTop < 90) {
          newTop = 90
        } else if (offsetTop + 36 > clientHeight) {
          newTop = clientHeight - 36
        }
        // 防止超出底部导航栏
        const navbarHeight = 90 // 设底部导航栏高度为90px
        if (newTop + 36 > clientHeight - navbarHeight) {
          newTop = clientHeight - navbarHeight - 36
        }
        selectDom.style.left = newLeft
        selectDom.style.top = newTop + 'px'
        this.btnType = (offsetLeft + 90) > (clientWidth / 2) ? 'right' : 'left'
      }
    }
  }
}
</script>

<style scoped>
.floatBtn {
  position: fixed;
  z-index: 1;
  border-radius: 50%;
  overflow: hidden;
  height: 4rem;
  width: 4rem;
  border-radius: 50%;
  left: calc(100% - 64px);
  right: calc(100% - 64px);
  top: calc(100% - 120px); /* 调整按钮位置，确保在底部导航栏上方 */
  box-sizing: border-box;
  padding: 10px;
}
.img-top-cover{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border-radius: 50%;
}
.floatBtn img.no-menu {
  z-index: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  -webkit-user-drag: none; /* 禁止图片拖动 */
  -webkit-touch-callout: none; /* 禁止长按图片显示默认菜单，持续长按微信的默认菜单依然会出现 */
}
</style>
